import { render, staticRenderFns } from "./UebersichtDiagnoseComponent.vue?vue&type=template&id=5268b205&scoped=true"
import script from "./UebersichtDiagnoseComponent.vue?vue&type=script&lang=js"
export * from "./UebersichtDiagnoseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268b205",
  null
  
)

export default component.exports